import { render, staticRenderFns } from "./InstructionsCard.vue?vue&type=template&id=0bee8db4&scoped=true&"
import script from "./InstructionsCard.vue?vue&type=script&lang=ts&"
export * from "./InstructionsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bee8db4",
  null
  
)

export default component.exports